import {
    getNumberAsLocaleNumber as getSharedNumberAsLocaleNumber,
    normalizeLocaleTag,
    truncate,
} from '@Sage/ssm-utils';

let USERLOCALE = 'en-US';

export const setupUserLocaleNumber = (locale) => {
    let tag = normalizeLocaleTag(locale);
    if (!tag) return;
    if (tag === 'es') tag = 'es-ES';
    if (tag === 'en') tag = 'en-US';
    USERLOCALE = tag;
};
export const getNumberAsLocaleNumber = (value, options = {}, useAllDecimals = false) => {
    return getSharedNumberAsLocaleNumber(value, options, useAllDecimals, USERLOCALE);
};

/**
 * If `value` parses to a finite number, return that number; otherwise return `value` unchanged.
 * Useful for B2/JSON request bodies where ids are numbers in the contract but may arrive as strings in JS.
 */
export const numberIfFinite = (value) => {
    const n = Number(value);
    return Number.isFinite(n) ? n : value;
};

export const randomId = () => {
    return Math.floor(Math.random() * 10000);
};

export const nFormatter = (num, digits) => {
    const lookup = [
        { value: 1e18, symbol: 'E' },
        { value: 1e15, symbol: 'P' },
        { value: 1e12, symbol: 'T' },
        { value: 1e9, symbol: 'G' },
        { value: 1e6, symbol: 'M' },
        { value: 1e3, symbol: 'k' },
        { value: 1, symbol: '' },
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    let item = lookup.find((item) => num >= item.value);
    return item ? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol : '0';
};
